jQuery.sidebar = {};
jQuery.sidebar.init = function(){
	'use strict';
	jQuery.sidebar.trigger();
};
jQuery.sidebar.trigger = function(){
	'use strict';
	var menuisOpened = false;

	jQuery(document).on('click', '.menu-button', function(e){
		e.preventDefault();
		if (menuisOpened === true) {
			jQuery("body").removeClass("menu-open");
			jQuery(".navbar").removeClass("menu-open");
			jQuery("#sidebar").removeClass("menu-open");
			jQuery("#template").removeClass("menu-open");
			jQuery(".menu-button").removeClass("toggled");
			jQuery("#sidebar-content").removeClass("menu-open");
			menuisOpened = false;
		} else {
			jQuery("body").addClass("menu-open");
			jQuery(".navbar").addClass("menu-open");
			jQuery("#sidebar").addClass("menu-open");
			jQuery("#template").addClass("menu-open");
			jQuery(".menu-button").addClass("toggled");
			menuisOpened = true;
		}
	});
	jQuery( window ).resize(function() {
		jQuery("body").removeClass("menu-open");
		jQuery("#sidebar").removeClass("menu-open");
		jQuery("#template").removeClass("menu-open");
		jQuery(".menu-button").removeClass("toggled");
		menuisOpened = false;
	});
};


jQuery(document).ready(function() {
	'use strict';
	jQuery.sidebar.init();
});
